export default {
  title: " PDF Validation",
  page: "Page",
  pages: "Pages",
  checkingFirstPageContent: "Checking first page content...",
  analyzingPdfContent: "Analyzing PDF content...",
  pdfHasNoPages: "PDF has no pages",
  pdfHasNoText: "PDF has no text",
  pdfHasNoTextOnFirstPage: "PDF has no text on first page",
  documentHasOnlyOnePage: "Document has only one page - it might be missing required information",
  processingPageContent: "Processing page content...",
  enhancingTextExtractionWithOcr: "Enhancing text extraction with OCR...",
  enhancingPage: "Enhancing page",
  processingPage: "Processing page",
  of: "of",
  textExtractionWithOcr: "Text extraction with OCR",
  textExtractionWithOcrFailed: "Text extraction with OCR failed on page",
  pdfBlankOrEmpty: "PDF appears to be blank or empty",
  errorDuringTextExtraction: "Error during text extraction",
  errorValidatingPdf: "Error validating PDF",
  startingDocumentAnalysis: "Starting document analysis...",
  documentPassedValidation: "Document passed validation",
  documentFailedValidation: "Document failed validation",
  downLoadFile: "Download file",
  invalidValues: "Invalid values",
  startingTextExtraction: "Starting text extraction...",
  close: "Close",
  confirmationTitle: "Confirmation",
  confirmationMessage: "Are you sure you want to close the validation?",
  coverLetterPassedValidation: "has passed validation",
  validationCategories: {
    documentType: "Document Type",
    certificateNumber: "Certificate Number",
    dates: "Dates",
    software: "Software",
    organizations: "Organizations",
    other: "Other",
  },
  requiredTextValidation: {
    title: " Required Text Validation:",
    notFound: "Nicht gefunden",
    found: "Gefunden",
  },
  warnings: {
    title: "Warnings:",
    noWarnings: "No warnings",
    withWarning: "with warning",
  },
  rescanPdf: {
    tooltipOCRExplain: "OCR (Optical Character Recognition) improves text extraction by recognizing text in images",
    useOcr: "use OCR",
    rescan: "Rescan",
  },
};
